import { createContext, useContext } from "react";

import { IUseDropdownItemsCtxProvider } from "../hooks";

const DropdownSourceContext = createContext<IUseDropdownItemsCtxProvider>(
  {} as IUseDropdownItemsCtxProvider,
);

DropdownSourceContext.displayName = "Dropdown Source";

export const useDropdownSourceContext = (): IUseDropdownItemsCtxProvider =>
  useContext(DropdownSourceContext);

export { DropdownSourceContext };
